module.exports = __webpack_public_path__ + "static/media/everyday_digital.cb0124ab.webp";